import React, { FC, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { loadChatConfig, loadChatStatus } from "./features/chatConfig/chatConfigSlice";
import getAvailablity from "./utils/getAvailablity";
import RemoveChat from "./components/RemoveChat/RemoveChat";
import Chatbot from "./features/chatbot/Chatbot";
import SurveyFrame from "./components/SurveyFrame/SurveyFrame";
import ChatFrame from "./components/ChatFrame/ChatFrame";
import { getStorage, resetStorage } from "./utils/helper";
import { closeIntroScreen } from "./features/chatbot/chatbotSlice";

const App: FC = () => {
  const searchParams = useRef(new URLSearchParams(window.location.search)).current;
  const dispatch = useAppDispatch();
  const { chatConfig, error, loading } = useAppSelector((state) => state.chatConfig);
  const { isEnded } = useAppSelector((state) => state.chatbot);

  useEffect(() => {
    if (searchParams.get("Value")) {
      dispatch(loadChatConfig(searchParams.get("Value") || "")).then(() => {
        let applicationId = "";
        let appMgr = null;
        try {
          appMgr = window.getAppWindow();
          if (appMgr && appMgr.application) {
            applicationId = appMgr && appMgr.application._id;
            const activityId = getStorage(applicationId, "activityId");
            if (activityId) {
              dispatch(loadChatStatus(activityId)).then(({ payload }: { payload: any }) => {
                if (payload && payload?.active) {
                  dispatch(closeIntroScreen());
                } else {
                  resetStorage();
                }
              });
            }
          }
        } catch (e: any) {}
      });
    }
  }, [dispatch, searchParams]);

  if (loading) {
    return null;
  } else if (error) {
    console.error(error);
    return <RemoveChat />;
  } else if (!chatConfig) {
    console.error(`Unable to load config`);
    return <RemoveChat />;
  } else {
    if (getAvailablity(chatConfig.config.queue1.availablity)) {
      return (
        <>
          <Chatbot />
          {isEnded ? <SurveyFrame /> : <ChatFrame />}
        </>
      );
    } else {
      return <RemoveChat />;
    }
  }
};
export default App;
